import { Markets } from '@/v2/v3/Markets'

// v3 rebuild: /markets renders the v3 Market Map (squarified treemap reusing
// FinvizMap's layout + data hooks, v3 chrome, shared shell). The legacy
// AppLayout-based body was trimmed in the B4 cleanup — see git history.
export function V2MarketsPage() {
  return <Markets />
}
